<p class="d-flex mx-auto my-3">
  {{ 'Sellers.Products.EnterFields' | translate }}
</p>

<app-form-builder-fielditem (formBuilderSave)="addingFormBuilderStep($event)"></app-form-builder-fielditem>
